if (!customElements.get('adelaide-product-tabs')) {
  customElements.define('adelaide-product-tabs', class extends HTMLElement {
    connectedCallback() {
      if (this.initialized) return;
      this.initialized = true;
      this.tabs = [...this.querySelectorAll('[role="tab"]')];
      this.tabs.forEach((tab, index) => {
        tab.addEventListener('click', () => this.select(index));
        tab.addEventListener('keydown', (event) => {
          let next = index;
          if (event.key === 'ArrowRight') next = (index + 1) % this.tabs.length;
          else if (event.key === 'ArrowLeft') next = (index - 1 + this.tabs.length) % this.tabs.length;
          else if (event.key === 'Home') next = 0;
          else if (event.key === 'End') next = this.tabs.length - 1;
          else return;
          event.preventDefault();
          this.select(next);
          this.tabs[next].focus();
        });
      });
      this.select(0);
      this.addEventListener('shopify:block:select', (event) => {
        const index = this.tabs.findIndex((tab) => tab.dataset.blockId === event.detail.blockId);
        if (index >= 0) this.select(index);
      });
    }
    select(index) {
      this.tabs.forEach((tab, i) => {
        tab.setAttribute('aria-selected', String(i === index));
        tab.tabIndex = i === index ? 0 : -1;
        this.querySelector(`[id="${tab.getAttribute('aria-controls')}"]`).hidden = i !== index;
      });
    }
  });
}
